import { connect } from 'react-redux'
import { NotesCard as NotesComponent } from 'transfix-ui/components/NotesCard'
import { getNotes, submitNote, submitCallback } from 'utils/actions/notes'

export const Notes = connect(
  ({
    childUsers: { users },
    notes: { notesAreLoading: fetching, notesError: error, notesList: notes },
    userProfile: { userProfileDetails },
  }) => ({
    noteableType: 'ParentUser',
    noteableId: userProfileDetails ? userProfileDetails.id : null,
    to: users[0],
    notes,
    fetching,
    error,
  }),
  { getNotes, submitNote, submitCallback }
)(NotesComponent)
